import moment from 'moment'
import { ref, type Ref } from 'vue'

export type DateRangeValue = [string, string]

export type DateRangePreset = {
  label: string
  range: () => DateRangeValue
}

export type UseCampaignDateRangeFilter = {
  range: Ref<DateRangeValue>
  presets: DateRangePreset[]
  setRange: (value: DateRangeValue) => void
}

const PICKER_FORMAT = 'YYYY-MM-DD HH:mm'

function createDefaultRange(): DateRangeValue {
  return [
    moment().subtract(30, 'days').startOf('day').format(PICKER_FORMAT),
    moment().startOf('day').format(PICKER_FORMAT)
  ]
}

/**
 * 期間ピッカーのプリセット 6 種と現在値・変更ハンドラ
 */
export function useCampaignDateRangeFilter(): UseCampaignDateRangeFilter {
  const range = ref<DateRangeValue>(createDefaultRange())

  const presets: DateRangePreset[] = [
    {
      label: '今月',
      range: () => [moment().startOf('month').format(PICKER_FORMAT), moment().format(PICKER_FORMAT)]
    },
    {
      label: '先月',
      range: () => [
        moment().subtract(1, 'month').startOf('month').format(PICKER_FORMAT),
        moment().startOf('month').format(PICKER_FORMAT)
      ]
    },
    {
      label: '過去14日前',
      range: () => [
        moment().subtract(14, 'days').startOf('day').format(PICKER_FORMAT),
        moment().startOf('day').format(PICKER_FORMAT)
      ]
    },
    {
      label: '過去30日前',
      range: () => [
        moment().subtract(30, 'days').startOf('day').format(PICKER_FORMAT),
        moment().startOf('day').format(PICKER_FORMAT)
      ]
    },
    {
      label: '過去3ヶ月前',
      range: () => [
        moment().subtract(3, 'month').startOf('day').format(PICKER_FORMAT),
        moment().startOf('day').format(PICKER_FORMAT)
      ]
    },
    {
      label: '過去6ヶ月前',
      range: () => [
        moment().subtract(6, 'month').startOf('day').format(PICKER_FORMAT),
        moment().startOf('day').format(PICKER_FORMAT)
      ]
    }
  ]

  const setRange = (value: DateRangeValue): void => {
    range.value = value
  }

  return {
    range,
    presets,
    setRange
  }
}
